<template>
    <div id="home">
        <div class="nav">
            <div class="logo">
                <img src="./../assets/images/xh_logo.png" alt="" v-if="wechatInfo.id == 1 && ['morumedia.cn','www.morumedia.cn'].indexOf(host) < 0">
            </div>
            <div class="gender">
                <div class="btn-group">
                    <button :class="{active:getType == 1}" @click="setType(1)">男生</button>
                    <button :class="{active:getType == 2}" @click="setType(2)">女生</button>
                </div>
            </div>
            <div class="user">
                <router-link :to="{name:'User'}" tag="div" class="iconfont paigusu-yonghu2">
                    <img :src="getCover" alt="" class="fr" :onerror.once="defaultUser">
                    <span class="mail" v-show="mailShow"></span>
                </router-link>
                <!--<router-link to="/signin" class="fr signin">签</router-link>-->

            </div>
        </div>

        <swiper :options="swiperOption" ref="mySwiper" class="banner" v-if="banner.length > 0">
            <!-- slides -->
            <swiper-slide v-for="item in getBanner" >
                <router-link :to="item.link">
                    <img :src="'http://static.yuread.cn/' + item.img" alt="">
                </router-link>
            </swiper-slide>

            <!-- Optional controls -->
            <div class="swiper-pagination"  slot="pagination"></div>

        </swiper>

        <div class="search">
            <button @click="searchbox = true;"><i class="el-icon-search"></i> {{defaultSearch}}</button>
        </div>


        <ul class="home-nav">
            <li class="classify">
                <router-link :to="{name:'Classify'}">
                    <img src="./../assets/images/classfiy.png" alt="">
                    <span>分类</span>
                </router-link>
            </li>
            <li class="ranking">
                <router-link :to="{name:'Rank'}">
                    <img src="./../assets/images/rank.png" alt="">
                    <span>排行榜</span>
                </router-link>
            </li>
            <li class="finish">
                <router-link :to="{name:'Finish'}" href="">
                    <img src="./../assets/images/library.png" alt="">
                    <span>完本</span>
                </router-link>
            </li>
            <li class="free">
                <router-link :to="{name:'Free'}">
                    <img src="./../assets/images/free.png" alt="">
                    <span>免费</span>
                </router-link>
            </li>

            <li class="okami">
                <router-link :to="{name:'Recharge'}">
                    <img src="./../assets/images/recharge.png" alt="">
                    <span>充值</span>
                </router-link>
            </li>

        </ul>
        <div class="currency dashen">
            <h3>大神佳作</h3>
            <ol class="ol-list">
                <li v-for="v in getdashen">
                    <router-link :to="v.link">
                        <img :src="'http://static.yuread.cn/' + v.img +'!thumb'" alt="">
                        <p class="title">{{v.title}}</p>

                    </router-link>
                </li>


            </ol>
        </div>
        <div class="currency ">
            <h3>主编力荐</h3>
            <ol class="ol-list">
                <li v-for="v in getLijian">
                    <router-link :to="v.link">
                        <img :src="'http://static.yuread.cn/' + v.img +'!thumb'" alt="">
                        <p class="title">{{v.title}}</p>

                    </router-link>
                </li>


            </ol>
        </div>
        <div class="currency ">
            <h3>新书推荐</h3>
            <ol class="ol-list">
                <li v-for="v in getXinshu">
                    <router-link :to="v.link">
                        <img :src="'http://static.yuread.cn/' + v.img +'!thumb'" alt="">
                        <p class="title">{{v.title}}</p>
                    </router-link>
                </li>


            </ol>
        </div>
        <div class="currency ">
            <h3>热门精选</h3>
            <ol class="ol-list">
                <li v-for="v in getRemen">
                    <router-link :to="v.link">
                        <img :src="'http://static.yuread.cn/' + v.img +'!thumb'" alt="">
                        <p class="title">{{v.title}}</p>

                    </router-link>
                </li>

            </ol>
        </div>
        <div class="currency ">
            <h3>热销排行榜</h3>
            <ul class="ul-list">
                <li v-for="v,i in getPaihang">
                    <router-link :to="v.link" v-if="i == 0">
                        <img :src="'http://static.yuread.cn/' + v.img +'!thumb'" alt="" class="bookcover fl">
                        <p class="title fl">{{v.title}}</p>
                        <img src="./../assets/images/no1.png" alt="" class="no fr">
                    </router-link>
                    <router-link :to="v.link" v-if="i == 1 || i == 2">
                        <img :src="require('./../assets/images/no' + (i+1)  + '.png')" alt="" class="no fl">
                        <p class="title fl">{{v.title}}</p>

                    </router-link>
                    <router-link :to="v.link" v-if="i > 2">
                        <span class="fl">{{i + 1 }}</span>
                        <p class="title fl">{{v.title}}</p>

                    </router-link>
                </li>


            </ul>
        </div>

        <div class="qrcode-box">
            <div class="mar">
                <img v-if="wechatInfo.username" :src="'https://open.weixin.qq.com/qr/code?username=' + wechatInfo.username" alt="" class="fl">
                <div class="fl">
                    <p >{{wechatInfo.nickname}}微信公众号</p>
                    <p >扫一扫，关注有惊喜</p>
                </div>

            </div>
        </div>

        <footer class="tc">
            <a href="http://author.yuread.net" v-if="wechatInfo.id == 1">作家中心</a>

            <p>
                {{wangwen}}
            </p>

            <p>
                <a href="https://beian.miit.gov.cn">{{icp}}</a>
            </p>
            <!--<p>Copyright © 2012-2022</p>-->
            <!--<p>北京众创众阅网络科技有限公司 版权所有</p>-->
            <!--<p>电话：010-57736683</p>-->
            <!--<p>地址：北京市昌平区回龙观镇立业路6号院2号楼2318室</p>-->
        </footer>

        <el-backtop ></el-backtop>

        <div class="search-box" v-if="searchbox">
            <div class="input-box">
                <i class="el-icon-search"></i>
                <input type="text" v-model="search" placeholder="" @keyup.enter="searchDo" v-focus="searchbox">
                <span v-if="search.length == 0" @click="searchbox = false">取消</span>
                <span v-if="search.length > 0" @click="searchDo">搜索</span>
            </div>


            <div class="hotsearch">
                <h3>热门搜索</h3>
                <router-link :to="v.link" v-for="v in sousou">{{v.describe || v.title}}</router-link>

            </div>

            <div class="historysearch" >
                <h3>搜索历史 <span class="fr" @click="delHistory"><i class="el-icon-delete"></i> 清空</span></h3>
                <p v-for="v in history"><router-link :to="{name:'Search',query: {search:v}}"> <i class="el-icon-time"></i> {{v}}</router-link></p>


            </div>

        </div>

        <router-link class="history" tag="div" to="/history">

            <p>最近</p>
            阅读
        </router-link>

    </div>
</template>

<script>
import {swiper,swiperSlide} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
    name: 'home',
    components:{
       swiper,swiperSlide
    },
    data(){
        return {
            host : '',
            swiperOption : {
                loop : true,
                observer:true,
                observeParents:true,
                autoplay : {
                    delay : 2000,
                    disableOnInteraction : false

                }
            },
            icp : '京ICP备17060968号-1',
            wangwen : '',
            defaultUser : 'this.src="'+require('./../assets/images/login.png')+'"',
            search : '',
            searchbox : false,
            history :[],

            wechatInfo : {},
            banner : [],
            dashen :[],

            lijian :[],
            xinshu :[],
            remen :[],
            paihang : [],
            sousou : [],
            mailShow : false,
        }
    },
    directives: {
        focus: {
            inserted: function (el, {value}) {
                console.log(el)
                console.log(value)
                if (value) {
                    el.focus();
                }
            }
        }
    },
    computed : {
        defaultSearch(){
            return this.getType == 1 ? '老北京时期一座古墓，专家得知墓主后吓出冷汗！' :''
        },
        getCover(){
            if(this.getUserInfo.cover.indexOf("http") != -1){
                return this.getUserInfo.cover;
            }
            return "http://static.yuread.cn/" + this.getUserInfo.cover;
        },
        getUserInfo(){
            return this.$store.getters.getUserInfo;
        },
        getType (){
            let userInfo = this.getUserInfo;
            if(userInfo.sex == 2){
                return 2
            }
            return 1;
        },
        getBanner(){
            let banner = [];
            this.banner.forEach(v =>{
                if(v.rid == this.getType){
                    banner.push(v);
                }

            })
            return banner;
        },
        getdashen(){
            let dashen = [];
            this.dashen.forEach(v =>{
                if(v.sex == this.getType){
                    dashen.push(v);
                }

            })
            return dashen;
        },
        getLijian(){
            let lijian = [];
            this.lijian.forEach(v =>{
                if(v.sex == this.getType){
                    lijian.push(v);
                }

            })
            return lijian;
        },
        getXinshu(){
            let xinshu = [];
            this.xinshu.forEach(v =>{
                if(v.sex == this.getType){

                    xinshu.push(v);
                }

            })
            return xinshu;
        },
        getRemen(){
            let remen = [];
            this.remen.forEach(v =>{
                if(v.sex == this.getType){
                    remen.push(v);
                }
            })
            return remen;
        },
        getPaihang(){
            let paihang = [];
            this.paihang.forEach(v =>{
                if(v.sex == this.getType){
                    paihang.push(v);
                }
            })
            return paihang;
        },

    },
    methods : {
        getHistory(){
            let history = sessionStorage.getItem('searchHistory');
            if(history){
                this.history = JSON.parse(history);
            }else{
                this.history = [];
            }
            ;
        },
        delHistory(){
            sessionStorage.removeItem('searchHistory');
            this.getHistory()
        },
        searchDo(){
            let history = sessionStorage.getItem('searchHistory');
            if(history){
                history = JSON.parse(history);
            }else{
                history = [];
            }
            if(history.indexOf(this.search) < 0){
                history.push(this.search);
                if(history.length > 10){
                    history.shift();
                }
                sessionStorage.setItem('searchHistory',JSON.stringify(history));
            }
            this.$router.push({name:'Search',query:{search : this.search}})
        },
        setType(sex){
            if(this.getType != sex){
                let userInfo = this.$store.getters.getUserInfo;
                userInfo.sex = sex;
                this.$store.dispatch('setUserInfo',userInfo);
            }
        },

        getIndex(){
            this.axios.post('/api/index/index',{

            }).then(r => {
                let data = r.data;
                if(data.code){
                    this.banner = data.data.banner;
                    this.dashen = data.data.dashen;
                    this.lijian = data.data.lijian;
                    this.xinshu = data.data.xinshu;
                    this.remen = data.data.remen;
                    this.paihang = data.data.paihang;
                    this.sousou = data.data.sousou;
                    this.mailShow = data.data.mail;
                    this.wechatInfo = data.data.wechatInfo;
                    document.title = this.wechatInfo.nickname;
                }

            })
        }

    },
    created(){
        this.host = window.location.host;
        switch (window.location.host) {
            case 'www.xinghe-cul.cn' :
                this.icp = '京ICP备18008549号-5';
                break;
            case 'xinghe-cul.cn' :
                this.icp = '京ICP备18008549号-5';
                break;
            case 'www.tianread.cn' :
                this.icp = '京ICP备17060968号-2';
                break;
            case 'tianread.cn' :
                this.icp = '京ICP备17060968号-2';
                break;
            case 'www.riread.cn' :
                this.icp = '京ICP备17060968号-5';
                break;
            case 'riread.cn' :
                this.icp = '京ICP备17060968号-5';
                break;
            case 'www.yuread.net' :
                this.icp = '京ICP备17060968号-10';
                break;
            case 'yuread.net' :
                this.icp = '京ICP备17060968号-10';
                break;
            case 'www.yuziran.cn' :
                this.icp = '京ICP备17060968号-4';
                break;
            case 'yuziran.cn' :
                this.icp = '京ICP备17060968号-4';
                break;
            case 'www.gggread.cn' :
                this.icp = '京ICP备17060968号-3';
                break;
            case 'gggread.cn' :
                this.icp = '京ICP备17060968号-3';
                break;
            case 'c1.xinghuozw.cn' :
                this.icp = '粤ICP备17023136号-6';
                break;
            case 'morumedia.cn' :
                this.icp = '琼ICP备2022013797号-1';
                this.wangwen = '网文证编号: 琼网文 （2023） 0373-037号';
                break;
            case 'www.morumedia.cn' :
                this.icp = '琼ICP备2022013797号-1';
                this.wangwen = '网文证编号: 琼网文 （2023） 0373-037号';
                break;
        }
    },
    mounted(){
        this.getIndex();
        this.getHistory();

    }
}
</script>
<style lang="less">
    #home{background: #f6f7f9;
        .search-box{ position:fixed;top:0;left:0;right:0;bottom:0;background: #fff;z-index: 999;
            .input-box{padding: 20px;border-bottom: 1px solid #efefef;position:relative;
                i{position:absolute;top: 36px; left :36px;font-size: 30px;color: #666;}
                input{width:600px;height: 60px;border-radius:60px;border:none;background:#F6F7F9;text-indent: 60px;font-size: 30px;}
                span{padding-left: 30px;font-size: 32px;color: #333;}
            }

            .hotsearch{padding: 20px;
                h3{font-size: 30px;border-left: 3px solid @theme;text-indent: 10px;font-weight: 400;color:#333;margin-bottom: 20px;}
                a{display:inline-block;background: #F6F7F9;margin: 0 20px 20px 0;padding:10px 30px;border-radius: 30px;font-size: 30px;color:#666;}
            }

            .historysearch{padding: 20px;border-top: 20px solid #f6f7f9;
                h3{font-size: 30px;border-left: 3px solid @theme;text-indent: 10px;font-weight: 400;color:#333;margin-bottom: 20px;
                    span{font-size: 26px;color: #999;}
                }
                p{line-height: 66px;border-top: 1px solid #efefef;font-size: 25px;color:#666;
                    i{font-size: 25px;color:#999;}
                }
            }
        }
        .nav{display: flex;height:104px;padding : 0 20px;
            >div{flex:1;}
            .logo{padding: 30px 0;
                img{width:150px;height: 42px;}
            }
            .gender{text-align: center;padding-top: 24px;
                .btn-group{width:212px;display: flex;border:1px solid @theme;border-radius: 8px;margin:0 auto;overflow: hidden;
                    button{flex: 1;border:none;background: none;height: 52px;font-size: 30px;color: @theme;}
                    button.active{background: @theme;color:#fff;}
                }
            }
            .user{padding-top: 25px;
                .signin{font-size: 28px;border-radius: 50%;color: @theme;margin-right: 10px;}
                img{width:40px;height:40px;border-radius:50%;}

                .paigusu-yonghu2{position: relative;padding: 10px 10px 0 0 ;
                    .mail{display: inline-block;width: 20px;height: 20px;background: red;position: absolute;top: 0;right: 0;border-radius: 50%;}
                }
            }
        }

        .el-carousel{
            height:300px;
        }
        .el-carousel__item{
            img{width:100%;height:300px;}
        }
        .banner{
            img{width:100%;height:300px;}
        }

        .search{padding: 20px;position: relative;width: 100%;
           button{width: 100%;border:none;background: #fff; height: 72px;line-height: 72px;border-radius: 5px;font-size: 28px;color:#999;}
        }

        .home-nav{display: flex;padding: 30px 0;background: #fff;text-align: center;margin: 5px 0 0;
            li{flex: 1;list-style: none;
                a{
                    img{width:52px;height:52px;display: block;margin:0 auto;}
                    span{font-size: 24px;color:#33373D;line-height: 50px;}
                }
            }

        }
        .currency {margin-top: 20px;
            padding: 20px;
            background: #fff;
            overflow: auto;

            h3 {
                border-left: 4px solid @theme;
                text-indent: 10px;
                margin-bottom: 20px;
                font-size: 32px;
                span{
                    text-indent:0;background: #33373d;color: #fff;font-size: 25px ;text-align: center;border-radius:5px;width: 40px;display: inline-block;
                }
                .day{
                    background: @theme;
                }

                a {
                    color: #666;
                    font-size: 28px;
                    float: right;

                    i {
                        font-size: 26px;
                    }
                }
            }
            .ul-list{
                li{overflow: hidden;margin-bottom: 10px;
                    p{margin-left: 20px;font-size: 28px;padding-top: 7px;color: #333;}
                    img{width:48px;height: 48px;}
                    span{color: #999;width:48px;text-align: center;padding-top: 7px;font-size: 26px;}
                }
                li:first-child{
                    .bookcover{width:92px;height: 122px;float: left;    box-shadow: 0 2px 6px rgba(0,0,0,.3);}
                }
            }

            .ol-list {
                white-space: nowrap;
                overflow-x: auto;
                overflow-y: hidden;
                padding: 0;
                a{width:100%;}
                li {
                    width: 215px;
                    margin-right: 30px;
                    display: inline-flex;

                    img {
                        width: 100%;
                        height: 280px;
                        box-shadow: 0 1PX 3PX rgba(0, 0, 0, .3);
                    }

                    .title {

                        color: #333;
                        line-height: 30px;
                        font-size: 26px;
                        font-weight: unset;
                        overflow: hidden;
                        white-space: initial;
                        text-overflow: ellipsis;
                    }

                    .author {
                        color: #8c939d;
                        width: 132px;
                        font-size: 26px;
                        font-weight: unset;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }


            .gender {
                text-align: center;
                line-height: 47px;
                margin-bottom: 20px;
                width: 100%;
                display: flex;

                button {
                    flex: 1;
                }


            }
        }
        .dashen{padding-right: 0;
            .ol-list {white-space: pre-wrap;overflow-x: auto;overflow-y: hidden;padding: 0;
                a {width: 100%;}

                li {width: 162px;margin-right: 20px;margin-bottom:20px;display: inline-flex;

                    img {width: 100%;height: 210px;box-shadow: 0 1PX 3PX rgba(0, 0, 0, .3);}
                }
            }
        }
        .qrcode-box{overflow: hidden;background: #fff;padding: 50px 0;
            margin-top: 20px;
            .mar{width:400px;overflow: auto;margin: 0 auto;
                div{padding-top: 50px;
                    p{font-size: 23px;}
                }
            }
            img{width:165px;height:165px;}
        }
        footer{padding: 20px;
            p{line-height: 60px;}
            a{color: #666;}
        }
        .el-backtop{
            width: 70px !important;
            height: 70px !important;
            i{font-size: 50px;}
        }

        .history{background: @theme;width:70px;height:70px;color:#fff;border-radius: 50%;font-size: 20px;text-align: center;padding-top: 4px;position:fixed;right:80px;bottom:180px;

        }

    }
</style>
